import { WHY_CHAPTERS, IMAGES } from "@/content/site";
import { Reveal } from "@/components/Reveal";

export const WhyChooseUs = () => (
  <section data-testid="why-choose-us-section" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-br from-deeppine via-pine to-[#0F3D30] text-white relative overflow-hidden">
    <div className="noise-overlay absolute inset-0 opacity-[0.04] pointer-events-none" />
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto relative">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="text-xs font-mono uppercase tracking-[0.25em] text-lagoonlight font-semibold">Why Point of Pines</p>
              <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15]">
                Why Pinellas County homeowners choose us
              </h2>
              <p className="mt-5 text-base text-emerald-50/70 leading-relaxed">
                Anyone can promise clean water. We built our company around the four things
                that actually make pool service worth paying for.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-10">
              <div className="clip-arch overflow-hidden ring-1 ring-white/15 shadow-2xl shadow-black/30">
                <img
                  src={IMAGES.waterTesting}
                  alt="Professional pool water testing and chemical balancing in Pinellas County FL"
                  className="w-full h-56 sm:h-64 object-cover"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          {WHY_CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <article
                data-testid={`why-chapter-${c.num}`}
                className="group flex gap-6 sm:gap-8 py-9 sm:py-11 border-b border-white/10 first:pt-0 last:border-b-0"
              >
                <span className={`font-mono text-sm sm:text-base pt-1.5 shrink-0 transition-colors duration-300 ${i % 2 ? "text-lagoonlight/80 group-hover:text-lagoonlight" : "text-sky2/80 group-hover:text-aqua"}`}>
                  {c.num}
                </span>
                <div>
                  <h3 className={`font-display text-xl sm:text-2xl font-semibold tracking-tight transition-colors duration-300 ${i % 2 ? "group-hover:text-lagoonlight" : "group-hover:text-sky2"}`}>
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm sm:text-base text-emerald-50/70 leading-relaxed max-w-xl">{c.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
